import script from "./CaptionSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptionSettings.vue?vue&type=script&setup=true&lang=js"

import "./CaptionSettings.vue?vue&type=style&index=0&id=21e10838&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21e10838"]])

export default __exports__